import { useState, useEffect, useRef } from 'react';
import styles from './infotabelle.module.css'; // or wherever your CSS module is

const InfoTabelle = ({ tabs }) => {
    const [activeIndex, setActiveIndex] = useState(0);
    const [isHovered, setIsHovered] = useState(false);
    const intervalRef = useRef(null);

    // Start interval logic
    useEffect(() => {
        if (!isHovered) {
            intervalRef.current = setInterval(() => {
                setActiveIndex(prev => (prev + 1) % tabs.length);
            }, 3000);
        }

        return () => {
            clearInterval(intervalRef.current);
        };
    }, [isHovered, tabs.length]);

    return (
        <div
            className={styles.highlightTabs}
        >
            <div className={styles.tabsHeader}>
                {tabs.map((tab, index) => (
                    <div tabIndex={0}
                        key={tab.title}
                        className={`${styles.tabItem} ${index === activeIndex ? styles.active : ''}`}
                        onClick={() => { setActiveIndex(index); setIsHovered(true) }}
                        onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === " ") {

                                e.preventDefault(); // Prevent space from scrolling
                                setActiveIndex(index)
                                setIsHovered(true)
                            }
                        }}
                    >
                        <p className={styles.title}>{tab.title}</p>
                    </div>
                ))}
            </div>
            <div className={styles.tabContent}>
                {tabs[activeIndex].content.map((text) =>
                (
                    <p className={styles.textContent}>{text}</p>
                )
                )}
            </div>
        </div>
    );
};

export default InfoTabelle;
